/**
 * 设备台账管理路由配置
 */
const deviceRoutes = {
  path: 'device',
  name: 'device',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'deviceList',
      component: () => import('./index.vue'),
      meta: {
        navtabTitle: '设备台账管理',
        isCache: true,
        ignoreDiff: [],
        isIframe: false
      }
    },
    {
      path: 'statistics-dashboard',
      name: 'deviceStatisticsDashboard',
      component: () => import('./statisticsDashboard.vue'),
      meta: {
        navtabTitle: '设备统计视图',
        isCache: false,
        ignoreDiff: [],
        isIframe: false
      }
    }
  ]
};

export default deviceRoutes;
